var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest.svg",
    clipPath: "url(#clip0_1107_508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9969 12.9C24.9969 19.8035 19.4036 25.3968 12.5 25.3968C11.21 25.3968 9.97044 25.2003 8.80138 24.8375C9.31032 24.006 10.0712 22.6455 10.3534 21.5621C10.5046 20.9776 11.1294 18.5891 11.1294 18.5891C11.5376 19.3651 12.7268 20.0252 13.9916 20.0252C17.7608 20.0252 20.4769 16.5583 20.4769 12.2499C20.4769 8.12292 17.1058 5.03397 12.7722 5.03397C7.38036 5.03397 4.51313 8.65202 4.51313 12.5976C4.51313 14.4318 5.49071 16.7145 7.04778 17.4401C7.28462 17.551 7.4106 17.5006 7.46603 17.2739C7.50634 17.1025 7.71798 16.2509 7.81372 15.8579C7.84396 15.7319 7.82884 15.621 7.72806 15.5001C7.21911 14.8702 6.80591 13.7213 6.80591 12.648C6.80591 9.89163 8.89208 7.22597 12.4497 7.22597C15.5184 7.22597 17.6701 9.31718 17.6701 12.3104C17.6701 15.6916 15.9619 18.0348 13.7397 18.0348C12.5152 18.0348 11.593 17.0219 11.8903 15.7773C12.2431 14.2907 12.9233 12.6883 12.9233 11.615C12.9233 10.6576 12.4093 9.85636 11.3411 9.85636C10.0863 9.85636 9.07853 11.1514 9.07853 12.8899C9.07853 13.9985 9.45142 14.7442 9.45142 14.7442C9.45142 14.7442 8.21685 19.9748 7.99009 20.9524C7.73813 22.0307 7.83892 23.5525 7.94474 24.5402C3.29872 22.7211 0.00317383 18.196 0.00317383 12.9C0.00317383 5.99644 5.59653 0.403076 12.5 0.403076C19.4036 0.403076 24.9969 5.99644 24.9969 12.9Z",
    fill: "#ab9788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9937,
    height: 25.8,
    fill: "white",
    transform: "translate(0.00317383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestGold);
export default __webpack_public_path__ + "static/media/pinterest_gold.d06ffb0a9fd39c76d6812583c65972b9.svg";
export { ForwardRef as ReactComponent };